import xss from "xss";

export const xssFilter = (
  content: string,
  whiteList: Record<string, string[]> = {}
) => {
  return xss(content, {
    whiteList, // Empty whiteList means no HTML tags are allowed
    stripIgnoreTag: true, // Completely strip out all HTML tags
    stripIgnoreTagBody: ["script"],
  });
};

export const xssFilterAllowToggleList = (content: string) => {
  return xssFilter(content, {
    details: [],
    summary: [],
    iframe: ["title", "lang", "id", "frameborder", "scrolling", "src", "style"],
    table: [],
    thead: [],
    tbody: [],
    tr: [],
    td: [],
    th: [],
    small: [],
    br: [],
  });
};
